module.exports = __webpack_public_path__ + "img/travel.2da8d30c.jpg";